/* Pizzamateur - Custom Polish JS v16 : popup (contraste refus, titre compact, 15s, neutralise le retard 45s) */
(function () {
  'use strict';
  const isHome = window.location.pathname === '/' || window.location.pathname === '/index' || window.location.pathname === '';
  const isProductPage = /\/products\//.test(window.location.pathname);

  function fixFirstImageLCP() {
    if (!isProductPage) return;
    document.querySelectorAll('slideshow-slide:first-of-type img, .slideshow-slide:first-of-type img, [class*="slideshow-slide"]:first-of-type img, [class*="slide__media"]:first-of-type img').forEach(img => {
      if (img.loading === 'lazy') { img.loading = 'eager'; img.setAttribute('fetchpriority', 'high'); }
    });
  }
  fixFirstImageLCP();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixFirstImageLCP);

  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealObserver = new IntersectionObserver(
      (entries) => { entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); } }); },
      { threshold: 0.1, rootMargin: '0px 0px -80px 0px' }
    );
    function setupReveals() {
      document.querySelectorAll('main .shopify-section').forEach((section, index) => { if (index === 0) return; section.classList.add('reveal-on-scroll'); revealObserver.observe(section); });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', setupReveals); } else { setupReveals(); }
  }

  function compressSeoBlock() {
    if (!isHome) return;
    const seoSection = document.querySelector('[id*="1776071606dd910c71"]');
    if (!seoSection || seoSection.dataset.pmCompressed === 'true') return;
    const longText = seoSection.querySelector('[class*="text"]');
    if (!longText) return;
    if (longText.offsetHeight < 400) return;
    longText.innerHTML = `<details class="pm-seo-details"><summary class="pm-seo-summary">En savoir plus sur Pizzamateur →</summary><div class="pm-seo-content">${longText.innerHTML}</div></details>`;
    seoSection.dataset.pmCompressed = 'true';
  }

  function injectBadges() {
    document.querySelectorAll('product-card, .product-card').forEach((card) => {
      if (card.querySelector('.pm-badge-promo')) return;
      const badge = document.createElement('div');
      badge.className = 'pm-badge-promo';
      badge.textContent = '−10% • BIENVENUE10';
      card.style.position = 'relative';
      card.appendChild(badge);
    });
    if (isHome) {
      document.querySelectorAll('main .shopify-section a[href*="/products/"]:not(.product-card__link):not(.pm-badge-injected):not(.pm-showcase__link)').forEach((link) => {
        const rect = link.getBoundingClientRect();
        if (rect.width < 200 || rect.height < 150) return;
        if (link.querySelector('.pm-badge-promo')) return;
        const badge = document.createElement('div');
        badge.className = 'pm-badge-promo';
        badge.textContent = '−10% • BIENVENUE10';
        link.classList.add('pm-badge-injected');
        if (getComputedStyle(link).position === 'static') link.style.position = 'relative';
        link.appendChild(badge);
      });
    }
  }

  function injectProductPromoBadge() {
    if (!isProductPage) return;
    document.querySelectorAll('.pm-product-promo').forEach(b => b.remove());
    let targetPrice = null;
    for (const el of document.querySelectorAll('[id*="price"], .price, [class*="product-price"], price-element, sale-price')) {
      if (el.closest('[class*="sticky"], [class*="floating"], floating-panel, [class*="cart-drawer"], [class*="mini"], dialog, [class*="modal"], [class*="popover"]')) continue;
      if (!el.closest('main')) continue;
      if (!el.offsetParent) continue;
      const rect = el.getBoundingClientRect();
      if (rect.width < 40 || rect.height < 15) continue;
      targetPrice = el; break;
    }
    if (!targetPrice) return;
    const badge = document.createElement('div');
    badge.className = 'pm-product-promo';
    badge.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg><span><strong>−10%</strong> avec le code <strong>BIENVENUE10</strong></span>`;
    targetPrice.parentNode.insertBefore(badge, targetPrice.nextSibling);
  }

  function fixCookieBannerText() {
    var m = document.getElementById('cookies-message');
    if (!m) return false;
    if (m.getAttribute('data-pm-text') === '1') return true;
    var link = m.querySelector('a');
    m.textContent = 'Nous utilisons des cookies pour assurer le bon fonctionnement du site, mesurer notre audience et améliorer votre expérience. Vous pouvez les accepter ou les refuser. ';
    if (link) m.appendChild(link);
    m.setAttribute('data-pm-text', '1');
    return true;
  }
  var pmCookieTries = 0;
  var pmCookieIv = setInterval(function () { if (fixCookieBannerText() || ++pmCookieTries > 60) clearInterval(pmCookieIv); }, 250);

  function runAll() { fixFirstImageLCP(); compressSeoBlock(); injectBadges(); injectProductPromoBadge(); fixCookieBannerText(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', runAll); } else { runAll(); }
  setTimeout(runAll, 1500);

  let resizeTimer;
  window.addEventListener('resize', () => { clearTimeout(resizeTimer); resizeTimer = setTimeout(injectBadges, 250); });

  function initPopupEmail() {
    const successRetour = /[?&]pm_news=ok/.test(window.location.search);
    if (!successRetour) {
      if (localStorage.getItem('pizzamateur_popup_seen') === 'true') return;
      if (sessionStorage.getItem('pizzamateur_popup_closed') === 'true') return;
    }
    const path = window.location.pathname;
    if (/\/(cart|checkout|account|customer_authentication|policies|challenge)/.test(path)) return;
    const realForm = document.getElementById('pm-popup-real-form');
    if (!realForm && !successRetour) return;
    const modal = document.createElement('div');
    modal.id = 'pizzamateur-popup';
    modal.innerHTML = `<style>.pm-popup-title{font-size:1.4rem;line-height:1.25;}.pm-popup-discount{display:block;font-size:3.1rem;line-height:1;margin-bottom:4px;font-weight:800;}.pm-popup-subtitle{font-size:0.92rem;}.pm-popup-decline{display:block;margin:18px auto 0;padding:8px 12px;background:none;border:0;font-family:'Inter',sans-serif;font-size:0.86rem;font-weight:500;color:rgba(31,46,28,0.75);text-decoration:underline;text-underline-offset:3px;cursor:pointer;transition:color .2s ease;}.pm-popup-decline:hover{color:#1f2e1c;}</style><div class="pm-popup-overlay" data-pm-close></div><div class="pm-popup-content" role="dialog" aria-labelledby="pm-popup-title" aria-modal="true"><div class="pm-popup-inner"><div class="pm-popup-badge">Offre de bienvenue</div><h2 id="pm-popup-title" class="pm-popup-title"><span class="pm-popup-discount">−10%</span>dès 35 € sur votre première commande</h2><p class="pm-popup-subtitle">Votre code arrive tout de suite par e-mail. Pas de spam.</p><div class="pm-popup-form-slot"></div><div class="pm-popup-success" hidden><div class="pm-popup-success-icon">✓</div><h3>Bienvenue !</h3><p>C'est noté ! Votre code −10% dès 35 € arrive dans votre boîte mail. Pensez à vérifier vos indésirables.</p></div><button type="button" class="pm-popup-decline" data-pm-close>Je refuse le cadeau</button><p class="pm-popup-footer-text">En vous inscrivant, vous acceptez notre <a href="/policies/privacy-policy">politique de confidentialité</a>.</p></div></div>`;
    document.body.appendChild(modal);
    modal.dataset.pmDelai = '1';
    const openPopup = () => { modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    const closePopup = () => { modal.classList.remove('is-open'); document.body.style.overflow = ''; sessionStorage.setItem('pizzamateur_popup_closed', 'true'); };
    modal.querySelectorAll('[data-pm-close]').forEach(el => el.addEventListener('click', closePopup));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && modal.classList.contains('is-open')) closePopup(); });
    if (successRetour) {
      modal.querySelector('.pm-popup-success').hidden = false;
      modal.querySelector('.pm-popup-decline').textContent = 'Fermer';
      modal.querySelector('.pm-popup-footer-text').hidden = true;
      localStorage.setItem('pizzamateur_popup_seen', 'true');
      try { history.replaceState(null, '', path); } catch (e) {}
      openPopup();
      return;
    }
    const rt = realForm.querySelector('input[name="return_to"]');
    if (rt) rt.value = path + '?pm_news=ok';
    modal.querySelector('.pm-popup-form-slot').replaceWith(realForm);
    realForm.hidden = false;
    const submitBtn = realForm.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.textContent = 'Recevoir mon code';
    realForm.addEventListener('submit', () => { localStorage.setItem('pizzamateur_popup_seen', 'true'); });
    let opened = false, exitArmed = false;
    const trigger = () => { if (!opened) { opened = true; openPopup(); } };
    setTimeout(trigger, 15000);
    setTimeout(() => { exitArmed = true; }, 18000);
    document.addEventListener('mouseleave', e => { if (!exitArmed) return; if (e.clientY > 5 || e.relatedTarget !== null) return; trigger(); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initPopupEmail); } else { initPopupEmail(); }

  function fixSubmenuHoverDelay() {
    if (!window.customElements || !window.customElements.whenDefined) return;
    customElements.whenDefined('header-menu').then(() => {
      const HeaderMenuClass = customElements.get('header-menu');
      if (!HeaderMenuClass || HeaderMenuClass._pmPatched) return;
      const proto = HeaderMenuClass.prototype;
      const originalDeactivate = proto.deactivate;
      if (typeof originalDeactivate !== 'function') return;
      proto.deactivate = function (event) {
        clearTimeout(this._pmDeactivateTimer);
        this._pmDeactivateTimer = setTimeout(() => {
          if (this.matches(':hover')) return;
          const activeSubmenus = this.querySelectorAll('[ref="submenu[]"], [data-active]');
          for (const sm of activeSubmenus) { if (sm.matches(':hover')) return; }
          try { originalDeactivate.call(this, event); } catch (e) {}
        }, 280);
      };
      document.addEventListener('pointermove', () => {
        document.querySelectorAll('header-menu').forEach((hm) => { if (hm._pmDeactivateTimer && hm.matches(':hover')) { clearTimeout(hm._pmDeactivateTimer); hm._pmDeactivateTimer = null; } });
      });
      HeaderMenuClass._pmPatched = true;
    }).catch(() => {});
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fixSubmenuHoverDelay); } else { fixSubmenuHoverDelay(); }
})();
